<script setup lang="ts">
import { computed } from 'vue'
import { groupByHeading } from './positions'
import type { PredefinedPosition } from './types'

const props = defineProps<{
  positions: PredefinedPosition[]
}>()

defineEmits<{
  pick: [position: PredefinedPosition]
}>()

const groups = computed(() => groupByHeading(props.positions))
</script>

<template>
  <div class="my-8 flex flex-col gap-4">
    <div v-for="(group, index) in groups" :key="group.group ?? index" class="flex flex-col gap-2">
      <span v-if="group.group" class="section-label">{{ group.group }}</span>

      <div class="flex flex-wrap gap-2">
        <button
          v-for="position in group.positions"
          :key="position.key"
          type="button"
          class="text-ink-2 bg-surface border-line hover:text-action hover:bg-surface-3 hover:border-action cursor-pointer rounded-full border border-dashed px-[11px] py-[5px] text-sm font-medium transition-colors duration-150"
          @click="$emit('pick', position)">
          + {{ position.label }}
        </button>
      </div>
    </div>
  </div>
</template>
